import { useState } from 'react';
import { cn } from '@/lib/utils';

/**
 * Drop a looping .mp4 at this path (controlUI/public/media/hero-loop.mp4)
 * to activate the video layer — until then the CSS aurora carries the look
 * on its own, so the screen never depends on the asset existing.
 */
const DEFAULT_VIDEO_SRC = '/media/hero-loop.mp4';

interface HeroBackgroundProps {
  videoSrc?: string;
  posterSrc?: string;
  className?: string;
}

export function HeroBackground({ videoSrc = DEFAULT_VIDEO_SRC, posterSrc, className }: HeroBackgroundProps) {
  const [videoFailed, setVideoFailed] = useState(false);

  return (
    <div className={cn('absolute inset-0 overflow-hidden bg-[#050b12]', className)} aria-hidden>
      <div className="aurora-bg absolute inset-0" />
      {!videoFailed && (
        <video
          className="absolute inset-0 h-full w-full object-cover opacity-70 mix-blend-screen motion-reduce:hidden"
          autoPlay
          muted
          loop
          playsInline
          preload="none"
          poster={posterSrc}
          onError={() => setVideoFailed(true)}
        >
          <source src={videoSrc} type="video/mp4" />
        </video>
      )}
      <div className="hero-grid absolute inset-0 opacity-[0.07]" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#050b12]/50 to-[#050b12]" />
    </div>
  );
}
